import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{},
    menuList:[]
  },
  mutations: {
    setUserInfo(state,val){
      state.userInfo = val;
      sessionStorage.setItem("userInfo",JSON.stringify(val))
    },
    setMenuList(state,val){
      state.menuList = val;
    },
  },
  getters:{
    getUserInfo(state){
      return state.userInfo;
    }, 
    getMenuList(state){
      return state.menuList;
    },
  },
  actions: {
  },
  modules: {
  }
})
